import React from "react";
import Banner from "../../components/Bannersection/banner";
import { Helmet } from "react-helmet";

function ReturnPolicy() {
  const pagename = [{ pagetitle: "Return and Cancellation Policy", subtitle: "Return Policy" }];

  return (
    <div>
      <Helmet>
        <title>DGi WORX Australia - Return and Cancellation Policy</title>
        <meta name="description" content="View DGi WORX Australia's Return and Cancellation Policy. Learn about our refund procedures, cancellation terms, and customer satisfaction commitments for our IT and digital services." />
        <meta name="keywords" content="Dgiworx, return policy, cancellation policy, refund policy, service cancellation, digital services refund, customer satisfaction, DGi WORX Australia" />
        <meta property="og:title" content="DGi WORX Australia - Return and Cancellation Policy" />
        <meta property="og:description" content="View DGi WORX Australia's Return and Cancellation Policy. Learn about our refund procedures, cancellation terms, and customer satisfaction commitments." />
        <meta property="og:image" content="/assets/img/dgiworx-home-embedded.jpg" />
        <meta property="og:url" content="https://dgiworx.com.au/return_policy" />
        <link rel="canonical" href="https://dgiworx.com.au/return_policy" />
      </Helmet>

      <Banner items={pagename} />

      <section className="Privacy">
        <div className="container">
          <div className="Privacypolicy">
            <h2>Return and Cancellation Policy</h2>
            <b>This policy outlines the terms and conditions regarding returns, refunds, and cancellations for services provided by DGi WORX (Australia).</b>
            <p>Last updated: April 10, 2026</p>
          </div>

          <div className="Privacypolicy">
            <h2>Cancellation Policy</h2>
            <p>At DGi WORX, we value our customers and strive to provide the best possible service. If you wish to cancel a service, please follow these guidelines:</p>
            <ul>
              <li><span><img src="/assets/img/icon/check-list.png" alt="" loading="lazy" /></span>Cancellations must be requested via email to our support team at <a href="mailto:support@dgiworx.com.au">support@dgiworx.com.au</a>.</li>
              <li><span><img src="/assets/img/icon/check-list.png" alt="" loading="lazy" /></span>For project-based services (e.g., Web Development, App Development), cancellation requests must be made before the project moves into the development phase.</li>
              <li><span><img src="/assets/img/icon/check-list.png" alt="" loading="lazy" /></span>For subscription-based services (e.g., SaaS products like Boox365), you can cancel your subscription at any time through your account settings or by contacting support. The cancellation will take effect at the end of the current billing cycle.</li>
            </ul>
          </div>

          <div className="Privacypolicy">
            <h2>Refund Policy</h2>
            <p>Our refund policy is designed to be fair and transparent and complies with the Australian Consumer Law (ACL):</p>
            <ul>
              <li><span><img src="/assets/img/icon/check-list.png" alt="" loading="lazy" /></span><span><b>Service-Based Refunds:</b> Since we provide digital services, refunds are generally not provided for work already performed. If you are dissatisfied with our service, please contact us within 7 days of delivery, and we will work with you to resolve any issues.</span></li>
              <li><span><img src="/assets/img/icon/check-list.png" alt="" loading="lazy" /></span><span><b>Product-Based Refunds:</b> For our software products, we offer a 7-day money-back guarantee if the product does not function as described and our technical team is unable to resolve the issue.</span></li>
              <li><span><img src="/assets/img/icon/check-list.png" alt="" loading="lazy" /></span><span><b>Consultation Fees:</b> Fees for initial consultations and strategy sessions are non-refundable.</span></li>
              <li><span><img src="/assets/img/icon/check-list.png" alt="" loading="lazy" /></span><span><b>Australian Consumer Law:</b> Nothing in this policy limits your rights under the Australian Consumer Law, including your right to a refund for major failures.</span></li>
            </ul>
          </div>

          <div className="Privacypolicy">
            <h2>Refund Processing</h2>
            <p>If a refund is approved, it will be processed using the original payment method:</p>
            <ul>
              <li><span><img src="/assets/img/icon/check-list.png" alt="" loading="lazy" /></span>Refunds typically take 5-10 business days to reflect in your account, depending on your bank or payment provider.</li>
              <li><span><img src="/assets/img/icon/check-list.png" alt="" loading="lazy" /></span>Transaction fees charged by payment gateways may be deducted from the refund amount.</li>
            </ul>
          </div>

          <div className="Privacypolicy">
            <h2>Contact Us</h2>
            <p><b>If you have any questions regarding our Return and Cancellation Policy, please reach out to us:</b></p>
            <ul>
              <li><span><img src="/assets/img/icon/check-list.png" alt="" loading="lazy" /></span>Email: <a href="mailto:support@dgiworx.com.au">support@dgiworx.com.au</a></li>
              <li><span><img src="/assets/img/icon/check-list.png" alt="" loading="lazy" /></span>Phone: <a href="tel:+610452573682">+61 0452573682</a></li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ReturnPolicy;
